import { put, select, takeEvery } from 'redux-saga/effects';
import { navigationActions, navigationSelectors } from './index';
import { goBack, replace } from 'connected-react-router';
import { ActionType } from '../../../utils/reduxUtils';

// Alternative implmentation without redux https://github.com/ReactTraining/history/issues/573
function* goBackOrReplace(action: ActionType<typeof navigationActions.goBackOrReplace>) {
  const previousLocation = yield select(navigationSelectors.selectPreviousLocation);
  const { replaceUrl, forceReplace } = action.payload;
  if (previousLocation === null || forceReplace === true) {
    if (typeof replaceUrl === 'string') {
      yield put(replace(replaceUrl as string));
    } else {
      yield put(replace(replaceUrl));
    }
  } else {
    yield put(goBack());
  }
}

const navigation = takeEvery(navigationActions.goBackOrReplace.type, goBackOrReplace);

const sagas = [navigation];

export default sagas;
